import React from 'react';

import { formatAccountNumber } from '@eika-infrastruktur/format';
import { copyToClipboard } from '@eika-infrastruktur/utils';
import { IconButton } from '@eika/button';
import { IconTypes } from '@eika/icon';

import AccountViewHeaderSkeleton from '../../components/AccountViewHeader/AccountViewHeaderSkeleton';
import { AccountLabels } from '../../components/shared/AccountLabels';
import { useAccount } from '../../fetchHooks/useAccount';
import useAccountId from '../../hooks/queryparams/useAccountId';
import useTranslation from '../../hooks/useTranslation';

const LoanViewHeader: React.FC = () => {
    const accountId = useAccountId();
    const { data: account, isLoading } = useAccount(accountId);
    const translated = useTranslation();

    if (isLoading || !accountId) {
        return <AccountViewHeaderSkeleton />;
    }

    if (!account) {
        return <h2>{translated.loanDetails.noLoan}</h2>;
    }

    return (
        <div className="loan-account-header__wrapper account-header__wrapper">
            <dl className="sgw-account-details__meta loan-title" itemScope itemType="https://schema.org/MortgageLoan">
                <dt className="screen-reader-text">{translated.loanOwners}</dt>
                <dd className="account-header__owners">
                    <AccountLabels owners={account.owners} />
                </dd>

                <dt className="screen-reader-text">{translated.loanName}</dt>
                <dd itemProp="name" className="account-details__name">
                    <h1 className="light">{account.alias}</h1>
                </dd>

                <dt className="screen-reader-text">{translated.accountNumber}</dt>
                <dd
                    itemProp="accountId"
                    className="account-details__accountId"
                    itemScope
                    itemType="https://schema.org/accountId"
                >
                    {formatAccountNumber(account.accountNumber)}
                    <IconButton
                        icon={IconTypes.COPY_24}
                        screenReaderText={translated.accountDetails.copyAccountNumber}
                        onClick={() => copyToClipboard(account.accountNumber.value)}
                    />
                </dd>
            </dl>
        </div>
    );
};

export default LoanViewHeader;
